import {Checkbox, Flex, theme, Typography} from 'antd';
import React from 'react';
import {dateConversionIsoToLocal, isValidISO8601} from 'Utils/helpers/DateValidation';

interface IProps {
  label: string;
  value?: any;
  type?: string;
  // Smaller, clamp()-bounded font sizes + bold value, laid out label-and-value
  // on a single line instead of stacked — used by the MemberDetailsPanel
  // sidebar's narrow column. AdminMemberProfile and Subscription's field grids
  // keep the default stacked layout and fixed sizes.
  compact?: boolean;
  // Bold value text without switching to the compact/single-line layout —
  // used by Subscription's field grid. AdminMemberProfile keeps normal weight.
  boldValue?: boolean;
}

// "Field row" pattern from the AST Console Revamp mockup (.field-row): a
// small uppercase tertiary label above the value.
const AdminDetailListItem: React.FC<IProps> = (props) => {
  const {label, value, type, compact = false, boldValue = false} = props;
  const {token}: any = theme.useToken();

  const labelNode = (
    <Typography.Text
      style={{
        fontSize: compact ? 'clamp(9px, 0.9vw, 10px)' : 11,
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: 0.4,
        color: token.colorTextTertiary,
        ...(compact && {width: 100, flexShrink: 0}),
      }}>
      {label}
    </Typography.Text>
  );

  const valueNode =
    type === 'checkbox' ? (
      <Checkbox checked={value} disabled />
    ) : (
      <Typography.Text
        style={{
          fontSize: compact ? 'clamp(10px, 1vw, 12px)' : 13,
          fontWeight: compact || boldValue ? 600 : undefined,
          color: token.colorText,
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          whiteSpace: 'normal',
          ...(compact && {flex: 1, minWidth: 0}),
        }}>
        {isValidISO8601(value) ? dateConversionIsoToLocal(value) : value || '-'}
      </Typography.Text>
    );

  if (compact) {
    return (
      <Flex align="center" gap={8} style={{width: '100%'}}>
        {labelNode}
        {valueNode}
      </Flex>
    );
  }

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: 3, width: '100%'}}>
      {labelNode}
      {valueNode}
    </div>
  );
};

export default AdminDetailListItem;
